import { motion } from 'motion/react'

const ZoomLogo = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 32 32" className="w-7 h-7" fill="none">
      <rect width="32" height="32" rx="4" fill="#2D8CFF"/>
      <path d="M8 11C8 10.45 8.45 10 9 10H16C16.55 10 17 10.45 17 11V21C17 21.55 16.55 22 16 22H9C8.45 22 8 21.55 8 21V11Z" fill="white"/>
      <path d="M18 13.5L24 10V22L18 18.5V13.5Z" fill="white"/>
    </svg>
    <span className="font-semibold text-sm">zoom</span>
  </div>
)

const CiscoLogo = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
      <rect x="2" y="8" width="2" height="8" rx="1"/>
      <rect x="6" y="5" width="2" height="14" rx="1"/>
      <rect x="10" y="2" width="2" height="20" rx="1"/>
      <rect x="14" y="5" width="2" height="14" rx="1"/>
      <rect x="18" y="8" width="2" height="8" rx="1"/>
    </svg>
    <span className="font-bold text-sm tracking-wide">CISCO</span>
  </div>
)

const FortinetLogo = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
      <path d="M12 2L3 7v10l9 5 9-5V7l-9-5zm0 2.5L18 8v8l-6 3.5L6 16V8l6-3.5z"/>
      <path d="M12 8v8l4-2.5V10.5L12 8z"/>
    </svg>
    <span className="font-bold text-sm tracking-wide">FORTINET</span>
  </div>
)

const RingCentralLogo = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 24 24" className="w-6 h-6">
      <path d="M20 12c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8" fill="none" stroke="#F47B20" strokeWidth="3" strokeLinecap="round"/>
      <circle cx="12" cy="12" r="3" fill="#F47B20"/>
    </svg>
    <span className="font-semibold text-sm">RingCentral</span>
  </div>
)

const MicrosoftLogo = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 21 21" className="w-5 h-5">
      <rect x="0" y="0" width="10" height="10" fill="#F25022"/>
      <rect x="11" y="0" width="10" height="10" fill="#7FBA00"/>
      <rect x="0" y="11" width="10" height="10" fill="#00A4EF"/>
      <rect x="11" y="11" width="10" height="10" fill="#FFB900"/>
    </svg>
    <span className="font-normal text-sm">Microsoft</span>
  </div>
)

const GenesysLogo = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 24 24" className="w-6 h-6">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.82 0 3.53-.49 5-1.35V12h-5v2.5h2.5c-.42 2.07-2.24 3.5-4.5 3.5-2.76 0-5-2.24-5-5s2.24-5 5-5c1.38 0 2.63.56 3.54 1.46L15.5 7.5C14.06 6.06 12.12 5.25 10 5.25 5.86 5.25 2.5 8.61 2.5 12.75S5.86 20.25 10 20.25c3.87 0 7.07-2.93 7.45-6.7H12V12h7v.75c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c2.49 0 4.74 1.01 6.36 2.64" fill="#FF4F1F"/>
    </svg>
    <span className="font-semibold text-sm" style={{color: '#FF4F1F'}}>Genesys</span>
  </div>
)

const Five9Logo = () => (
  <div className="flex items-center gap-2">
    <svg viewBox="0 0 24 24" className="w-6 h-6">
      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z" fill="#6B2B90"/>
    </svg>
    <span className="font-bold text-sm" style={{color: '#6B2B90'}}>Five9</span>
  </div>
)

const Logo8x8 = () => (
  <div className="flex items-center gap-1">
    <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
      <circle cx="8" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="16" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="8" cy="16" r="4" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="16" cy="16" r="4" fill="none" stroke="currentColor" strokeWidth="2"/>
    </svg>
    <span className="font-bold text-sm">8x8</span>
  </div>
)

const partners = [
  { name: 'Zoom', Logo: ZoomLogo, url: 'https://zoom.us' },
  { name: 'Cisco', Logo: CiscoLogo, url: 'https://cisco.com' },
  { name: 'Fortinet', Logo: FortinetLogo, url: 'https://fortinet.com' },
  { name: 'RingCentral', Logo: RingCentralLogo, url: 'https://ringcentral.com' },
  { name: 'Microsoft', Logo: MicrosoftLogo, url: 'https://microsoft.com' },
  { name: 'Genesys', Logo: GenesysLogo, url: 'https://genesys.com' },
  { name: 'Five9', Logo: Five9Logo, url: 'https://five9.com' },
  { name: '8x8', Logo: Logo8x8, url: 'https://8x8.com' },
]

export function PartnerLogos() {
  return (
    <div className="bg-primary-600/50 py-12 border-y border-white/5">
      <div className="container-custom">
        <p className="text-center text-sm font-medium text-slate-500 uppercase tracking-widest mb-10">
          Technology Partners & Certified Integrations
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {partners.map((partner, index) => (
            <motion.a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="text-slate-400 hover:text-white transition-colors duration-300"
              title={partner.name}
            >
              <partner.Logo />
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  )
}


